import { getLanesRoot } from '../services/LaneService';

import { is } from '../../../base/BaseServices';

import { isAny } from '../services/ModelingService';

var HIGH_PRIORITY = 1500;
var HIGHEST_PRIORITY = 2000;


/**
 * Correct hover targets in certain situations to improve diagram interaction.
 *
 * @param {ElementRegistry} elementRegistry
 * @param {EventBus} eventBus
 * @param {Canvas} canvas
 */
export default function FixHoverAction(elementRegistry, eventBus, canvas) {

  eventBus.on([
    'create.hover',
    'create.move',
    'create.out',
    'create.end',
    'shape.move.hover',
    'shape.move.move',
    'shape.move.out',
    'shape.move.end'
  ], HIGH_PRIORITY, function (event) {
    var context = event.context,
      shape = context.shape || event.shape,
      hover = event.hover;
  
    handleLaneDrop(event, hover, shape);
  
    handleGroupAndLabelDrop(event, hover, shape);
  });
  
  function handleLaneDrop(event, hover, shape) {
    if (isLaneAndNotParticipant(hover, shape)) {
      event.hover = getLanesRoot(hover);
      event.hoverGfx = elementRegistry.getGraphics(event.hover);
    }
  }
  
  function isLaneAndNotParticipant(hover, shape) {
    return is(hover, 'bpmn:Lane') && !isAny(shape, ['bpmn:Lane', 'bpmn:Participant']);
  }
  
  function handleGroupAndLabelDrop(event, hover, shape) {
    var rootElement = canvas.getRootElement();
  
    if (shouldDropOnRoot(hover, shape, rootElement)) {
      event.hover = rootElement;
      event.hoverGfx = elementRegistry.getGraphics(event.hover);
    }
  }
  
  function shouldDropOnRoot(hover, shape, rootElement) {
    return hover !== rootElement && (shape.labelTarget || is(shape, 'bpmn:Group'));
  }
  

  eventBus.on([
    'connect.hover',
    'connect.out',
    'connect.end',
    'connect.cleanup',
    'global-connect.hover',
    'global-connect.out',
    'global-connect.end',
    'global-connect.cleanup'
  ], HIGH_PRIORITY, function (event) {
    handleLaneConnection(event);
  });
  
  function handleLaneConnection(event) {
    var hover = event.hover;
  
    if (isLane(hover)) {
      updateHoverForLaneConnection(event, hover);
    }
  }
  
  function updateHoverForLaneConnection(event, hover) {
    event.hover = getLanesRoot(hover) || hover;
    event.hoverGfx = elementRegistry.getGraphics(event.hover);
  }  


  eventBus.on(['bendpoint.move.hover'], HIGH_PRIORITY, function (event) {
    handleLaneReconnectHover(event);
  });
  
  function handleLaneReconnectHover(event) {
    var context = event.context,
      hover = event.hover,
      type = context.type;
  
    if (isLane(hover) && isReconnectType(type)) {
      updateHoverForLaneReconnect(event, hover);
    }
  }
  
  function isReconnectType(type) {
    return /reconnect/.test(type);
  }
  
  function updateHoverForLaneReconnect(event, hover) {
    event.hover = getLanesRoot(hover) || hover;
    event.hoverGfx = elementRegistry.getGraphics(event.hover);
  }  


  eventBus.on(['connect.start'], HIGH_PRIORITY, function (event) {
    updateConnectStart(event);
  });
  
  function updateConnectStart(event) {
    var context = event.context,
      start = context.start;
  
    if (isLane(start)) {
      context.start = getLanesRoot(start) || start;
    }
  }


  // allow movement of participants from lanes
  eventBus.on('shape.move.start', HIGHEST_PRIORITY, function (event) {
    updateMoveStart(event);
  });
  
  function updateMoveStart(event) {
    var shape = event.shape;
  
    if (isLane(shape)) {
      event.shape = getLanesRoot(shape) || shape;
    }
  }
  
  function isLane(element) {
    return is(element, 'bpmn:Lane');
  }
  

}

FixHoverAction.$inject = [
  'elementRegistry',
  'eventBus',
  'canvas'
];